import { scrollToTarget } from './hash-navigation';

const isMobile = window.matchMedia('(max-width: 980px)').matches;

const echoBlock = {
  wrapper: <HTMLElement>document.querySelector('.echo-block'),
  selectors: <NodeListOf<HTMLElement>>document.querySelectorAll('.echo-block__selector-bar li'),
  contentBlocks: <NodeListOf<HTMLElement>>document.querySelectorAll('.echo-block__content'),
  videos: <NodeListOf<HTMLVideoElement>>document.querySelectorAll('.echo-block__content-image'),
};

function switchToIndex(index: number, animate: boolean = true) {
  echoBlock.selectors.forEach((selector) => {
    selector.classList.remove('active');
  });
  echoBlock.contentBlocks.forEach((contentBlock) => {
    contentBlock.classList.remove('active');
  });

  echoBlock.selectors[index].classList.add('active');
  echoBlock.contentBlocks[index].classList.add('active');

  if (animate) {
    scrollToTarget(document.querySelector('.echo-block'), 50, 500);
  }
}

function addListeners() {
  echoBlock.selectors.forEach((selector) => {
    selector.addEventListener('click', () => {
      switchToIndex(parseInt(selector.dataset.index, 10));
    });
  });
}

if (!isMobile) {
  addListeners();
  switchToIndex(0, false);
}
